/**
 * Légende overlay du MapWidget (PR-3 double encodage) : taille = 1re métrique
 * (cercles de référence), couleur = 2e métrique (barre dégradée min→max).
 *
 * Composant présentational pur, pas de dépendance Leaflet : positionné en
 * absolu par le parent (`MapWidget`), en bas-gauche pour éviter le contrôle
 * « Figer / Réinitialiser » (haut-droite) et l'attribution Leaflet (bas-droite).
 */
import { formatMetricValue, type MetricFormat } from '../formatValue';
import { RAMP_FROM, RAMP_TO } from './mapColors';

interface MapLegendProps {
  sizeLabel: string;
  sizeMax: number;
  sizeFormat: MetricFormat;
  /** Absent → pas de section couleur (une seule métrique configurée). */
  colorLabel?: string;
  colorMin?: number;
  colorMax?: number;
  colorFormat?: MetricFormat;
}

export default function MapLegend({
  sizeLabel,
  sizeMax,
  sizeFormat,
  colorLabel,
  colorMin,
  colorMax,
  colorFormat,
}: MapLegendProps) {
  return (
    <div className="absolute bottom-2 left-2 z-[500] rounded-md bg-white/90 px-2.5 py-2 text-[11px] shadow">
      <div className="flex items-center gap-2">
        <span className="text-[#8B8FA7]">Taille = {sizeLabel}</span>
        <span className="flex items-center gap-1">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#6366F1]" />
          <span className="inline-block h-3 w-3 rounded-full bg-[#6366F1]" />
          <span className="text-[#1B2559]">{formatMetricValue(sizeMax, sizeFormat)}</span>
        </span>
      </div>
      {colorLabel && (
        <div className="mt-1.5 flex items-center gap-2">
          <span className="text-[#8B8FA7]">Couleur = {colorLabel}</span>
          <span
            className="h-2 w-12 rounded"
            style={{ background: `linear-gradient(90deg, ${RAMP_FROM}, ${RAMP_TO})` }}
          />
          <span className="text-[#1B2559]">
            {formatMetricValue(colorMin ?? 0, colorFormat)} → {formatMetricValue(colorMax ?? 0, colorFormat)}
          </span>
        </div>
      )}
    </div>
  );
}
